module.exports = __webpack_public_path__ + "static/media/img2.36cfb6fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/About/img2.jpg
// module id = 113
// module chunks = 0